import React from 'react';

const AboutUsabout = () => {
  return (
    <section className="about-us pb-0">
      <div
        className="section-shape section-shape1"
        style={{ backgroundImage: 'url(images/shape8.png)' }}
      ></div>
      <div className="container">
        <div className=" mb-6 w-5 mx-auto text-center">
          <h4 className="mb-1 theme1">Core Features</h4>
          <h2 className="mb-1">
            Discover the Weekend Retreat at <span className="theme">Morachi Chincholi</span>
          </h2>
          <p>
         Immerse yourself in the natural beauty, where peacocks roam freely, and enjoy a blend of cultural experiences and serene landscapes.
          </p>
        </div>

        {/* Why Us Section */}
        <div className="why-us">
          <div className="why-us-box">
            <div className="row">
              {/* First Item */}
              <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                  <div className="why-us-content">
                    <div className="why-us-icon mb-1">
                      <i className="icon-flag theme"></i>
                    </div>
                    <h4>
                      <a href="about.html">Outdoor Adventures: NCC & RSP Camps and Picnics</a>
                    </h4>
                    <p className="mb-2">
                      Schools and organizations planning weekend stays at Chincholi Morachi can benefit from the opportunity to arrange NCC & RSP camps or picnics, utilizing the serene surroundings for outdoor activities and team-building exercises.


                    </p>
                    {/* <p className="mb-0 theme">100+ Reviews</p> */}
                  </div>
                </div>
              </div>

              {/* Second Item */}
              <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                  <div className="why-us-content">
                    <div className="why-us-icon mb-1">
                      <i className="icon-location-pin theme"></i>
                    </div>
                    <h4>
                      <a href="about.html">Camping and Tent Services in the Serene Countryside</a>
                    </h4>
                    <p className="mb-2">
                      With camping and tent services readily available, visitors to Morachi Chincholi can enjoy a comfortable and immersive outdoor experience, surrounded by the natural beauty of the countryside.
                    </p>
                    {/* <p className="mb-0 theme">100+ Reviews</p> */}
                  </div>
                </div>
              </div>

              {/* Third Item */}
              <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                  <div className="why-us-content">
                    <div className="why-us-icon mb-1">
                      <i className="icon-directions theme"></i>
                    </div>
                    <h4>
                      <a href="about.html">Spiritual Retreat: Meditation in Natural Silence</a>
                    </h4>
                    <p className="mb-2">
                      Guests seeking moments of tranquility and self-reflection can capitalize on the natural silence of Morachi Chincholi for meditation, tapping into the peaceful atmosphere to enhance their spiritual well-being.
                    </p>
                    {/* <p className="mb-0 theme">100+ Reviews</p> */}
                  </div>
                </div>
              </div>

              {/* Fourth Item */}
              <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                  <div className="why-us-content">
                    <div className="why-us-icon mb-1">
                      <i className="icon-compass theme"></i>
                    </div>
                    <h4>
                      <a href="about.html">Fun in the Sun: Open Space for Outdoor Games</a>
                    </h4>
                    <p className="mb-2">
                      Morachi Chincholi boasts ample open spaces, perfect for engaging in a variety of outdoor games and recreational activities, providing both fun and relaxation for visitors of all ages.
                    </p>
                    {/* <p className="mb-0 theme">100+ Reviews</p> */}
                  </div>
                </div>
              </div>



            <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                  <div className="why-us-content">
                    <div className="why-us-icon mb-1">
                      <i className="icon-compass theme"></i>
                    </div>
                    <h4>
                      <a href="about.html">Seasonal Delights: Fruitful Voyage at Morachi Chincholi</a>
                    </h4>
                    <p className="mb-2">
                     Indulge in a delightful culinary journey with Morachi Chincholi's seasonal fruits, including sweet mangoes, bananas, tangy tamarind, and creamy custard apples, adding a burst of flavor to your weekend retreat.
                    </p>
                    {/* <p className="mb-0 theme">100+ Reviews</p> */}
                  </div>
                </div>
              </div>


               <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                  <div className="why-us-content">
                    <div className="why-us-icon mb-1">
                      <i className="icon-compass theme"></i>
                    </div>
                    <h4>
                      <a href="about.html">Winter Wonders: Hurda Parties and Bonfire Delights</a>
                    </h4>
                    <p className="mb-2">
                      During the chilly winter season, Morachi Chincholi comes alive with festive hurda parties, featuring traditional delicacies like Chulivarchya Bhakri and Zoonka, accompanied by crackling bonfires that provide warmth and camaraderie for all.
                    </p>
                    {/* <p className="mb-0 theme">100+ Reviews</p> */}
                  </div>
                </div>
              </div>






            </div>
          </div>
        </div>
        {/* End of Why Us Section */}
      </div>
    </section>
  );
};

export default AboutUsabout;
